import type React from 'react'
import { cn } from '../lib/cva'

// Inline SVG checkmark
const Checkmark = () => (
	<svg width='22' height='22' viewBox='0 0 22 22' fill='none' aria-hidden='true'>
		<path
			d='M6 11.5L10 15.5L16 8.5'
			stroke='currentColor'
			strokeWidth='2.2'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
)

export interface Step {
	label: string
	completed?: boolean
}

interface StepsProps {
	steps: Step[]
	currentStep: number
	onStepChange?: (stepIdx: number) => void
	clickable?: boolean[]
	className?: string
}

export const Steps: React.FC<StepsProps> = ({ steps, currentStep, onStepChange, clickable, className }) => {
	return (
		<div className={cn('flex items-center gap-8', className)}>
			{steps.map((step, idx) => {
				const isCompleted = step.completed
				const isActive = idx === currentStep
				const canClick = clickable?.[idx] ?? true
				return (
					<div key={step.label} className={cn('flex items-center p-6', isActive && 'border-b-primary-600 border-b-4')}>
						<button
							type='button'
							disabled={!canClick}
							onClick={() => canClick && onStepChange?.(idx)}
							className={cn('flex items-center focus:outline-none', canClick ? 'cursor-pointer' : 'cursor-default')}>
							<span
								className={cn(
									'w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold border-2',
									isCompleted
										? 'bg-primary-600 text-neutral-0 border-primary-600'
										: isActive
											? 'bg-primary-600 text-neutral-0 border-primary-600'
											: 'bg-neutral-500 text-neutral-0 border-gray-500',
								)}>
								{isCompleted ? <Checkmark /> : idx + 1}
							</span>
							<span className={cn('ml-3 text-sm text-neutral-800', isActive && 'font-semibold')}>{step.label}</span>
						</button>
					</div>
				)
			})}
		</div>
	)
}

export default Steps
